export type VariantSortKey = 'brand' | 'origin';
export type VariantSort = { key: VariantSortKey; dir: 'asc' | 'desc' } | null;

// Client-side sort for the grid's SEED order (this grid holds the whole family in one
// fetch — there is no server-side sort to defer to). Pure reorder, same contract as
// sortHighlightedFirst: no items added, removed, or mutated. Empty values sink to the
// bottom regardless of direction so the rows being visually compared stay contiguous.
// Returns the input array by reference when sort is null so memo identities hold.
export function sortVariantsByField<T extends { brand?: string | null; origin?: string | null }>(
  variants: T[],
  sort: VariantSort
): T[] {
  if (!sort) return variants;
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...variants].sort((a, b) => {
    const av = (a[sort.key] ?? '').trim();
    const bv = (b[sort.key] ?? '').trim();
    if (!av && !bv) return 0;
    if (!av) return 1;
    if (!bv) return -1;
    return av.localeCompare(bv, undefined, { sensitivity: 'base' }) * dir;
  });
}
